import { FaireHelmet } from "@faire/deprecated-retailer-visitor-shared/components/Helmet/index";
import { useFormattedOfferedMaxTerms } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import {
  DEPRECATED_backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web/common/localization";
import React from "react";

export const OpenWithFaireHelmet: React.FC = () => {
  const previewImage = IImage.build({
    url: "https://cdn.faire.com/fastly/e6b6149dfa11ebca73e3b67a169775b6184d56a4aaa4566f85f642fd4c43f056.png",
    width: 600,
    height: 456,
  });
  const formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();
  const { strictLocalize } = useStrictLocalization();
  return (
    <FaireHelmet
      title={strictLocalize(
        {
          id: "FA2BbC",
          defaultMessage:
            "Open with Faire | Get up to {maxTermsMoney} to spend on inventory for your store",
          description: { text: "Title of a page" },
        },
        {
          maxTermsMoney: formattedOfferedMaxTerms,
        }
      )}
      description={strictLocalize(
        {
          id: "sQkOU1",
          defaultMessage:
            "Get up to {amount} in 60-day payment terms and discover high-quality products from thousands of independent brands, all in the Faire marketplace.",
        },
        DEPRECATED_backwardsCompatibleValues({
          amount: formattedOfferedMaxTerms,
        })
      )}
      image={previewImage}
    />
  );
};
